<template>
    <input
        type="text"
        inputmode="decimal"
        name="bidAmount"
        autocomplete="false"
        v-model.lazy.trim="bidAmountFormatted"
        maxlength="20"
        class="bid-input form-control input-gray"
        ref="bidAmount"
        :placeholder="placeholder || $t('Generic.placeholder.bidAmount')"
        required
        :aria-label="$t('Generic.placeholder.bidAmount')"
    />
</template>

<script>
export default {
    name: 'BidInput',

    data() {
        return {
            currencySign: '€' // can be computed from locale with the help of Intl.NumberFormat.prototype.formatToParts(value)
        };
    },

    props: {
        value: {
            //type: [Number, Null] - cannot use nullable type declaration here
            required: true
        },

        placeholder: {
            type: String
        }
    },

    computed: {
        bidAmountFormatted: {
            get() {
                // initial value or removed value
                if (!this.value) {
                    return null;
                }

                // Why NumberFormat style: 'currency'? It deals better with only 2 decimals allowed
                const formattedString = this.formatWithoutCurrencySign(this.value / 100);
                // incorrect value attempted to be formatted
                if (!this.validateFormattedString(formattedString)) {
                    return this.value; // no formatting for incorrect values
                }
                // correctly formatted string
                return `${formattedString}${this.currencySign}`;
            },
            set(value) {
                let noCurrency = this.removeCurrencySign(value).trim();

                const endsWithDotAndTwoNumbers = Number.parseFloat(noCurrency.slice(-3)) < 1;
                if (endsWithDotAndTwoNumbers) {
                    noCurrency = noCurrency.replace(/[.](\d{2})(?!\d)/, ',$1'); // replaces last dot followed by 2 digits with comma
                }
                const trimmedAndNumeric = noCurrency.replace(/\./g, '').replace(',', '.');
                const formattedString = this.formatWithoutCurrencySign(trimmedAndNumeric);

                if (this.validateFormattedString(formattedString)) {
                    // Currency number format will force decimals, no need to multiply by 100
                    const euroCentsString = formattedString.replace(/\.|,/g, '');
                    this.$emit('input', Math.abs(euroCentsString));
                }
            }
        }
    },

    methods: {
        removeCurrencySign(value) {
            const regex = new RegExp('\s?' + this.currencySign);
            return (value || '').replace(regex, ''); // space before currency is optional (user may delete it when typing)
        },
        formatWithoutCurrencySign(value) {
            return this.removeCurrencySign(
                new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value || '')
            );
        },
        validateFormattedString(value) {
            // properly formatted 1.123,23 will give isNaN true, so just looking for NaN part to check
            return value && !value.includes('NaN');
        }
    }
};
</script>
